<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row content-block mt-2">
      @if (this.vehicleId > 0) {
        <h4>New Defect for: {{this.vehicle.registration}}</h4>
      }
      @if (this.vehicleId <= 0) {
        <h4>New Defect, show vehicle list</h4>
      }
    </div>

    <div class="row">
      <div class="col">
        <app-defect-form
          [defect]='this.defect'
          [vehicle]='this.vehicle'
          [editToggle]='true'
        ></app-defect-form>
      </div>
    </div>

    <div class="row">
      <div class="col btn-group">
        <button class='btn btn-success' (click)='save()'>Save</button>
        <button class='btn btn-danger' (click)='cancel()'>Cancel</button>
      </div>
    </div>
  </div>
</div>
